/**
 * Iconos de línea para los sectores de experiencia. Sobrios, stroke
 * currentColor, sin relleno — coherentes con el design system (sin emoji).
 *
 * <SectorIcon id="transporte" size={28} />
 */

const PATHS = {
  transporte: (
    <>
      <path d="M3 7h11v9H3z" />
      <path d="M14 10h4l3 3v3h-7z" />
      <circle cx="7" cy="18" r="1.6" />
      <circle cx="17" cy="18" r="1.6" />
    </>
  ),
  retail: (
    <>
      <path d="M5 8h14l-1 12H6z" />
      <path d="M9 8V6a3 3 0 0 1 6 0v2" />
    </>
  ),
  inmobiliario: (
    <>
      <path d="M4 20V9l8-5 8 5v11" />
      <path d="M10 20v-5h4v5" />
      <path d="M4 20h16" />
    </>
  ),
  agroindustria: (
    <>
      <path d="M12 20v-8" />
      <path d="M12 12c0-3 2-5 6-5 0 3-2 5-6 5z" />
      <path d="M12 14c0-3-2-5-6-5 0 3 2 5 6 5z" />
      <path d="M7 20h10" />
    </>
  ),
  'sin-fines-de-lucro': (
    <>
      <path d="M12 20s-7-4.3-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.7-7 9-7 9z" />
    </>
  ),
  cultura: (
    <>
      <path d="M5 20V8l7-4 7 4v12" />
      <path d="M9 20v-9M15 20v-9" />
      <path d="M4 8h16" />
    </>
  ),
  'empresas-familiares': (
    <>
      <circle cx="8" cy="9" r="2.4" />
      <circle cx="16" cy="9" r="2.4" />
      <path d="M4 19c0-2.5 1.8-4 4-4s4 1.5 4 4" />
      <path d="M12 19c0-2.5 1.8-4 4-4s4 1.5 4 4" />
    </>
  ),
  startups: (
    <>
      <path d="M12 3c3.5 2 5 5.5 5 9l-2 4H9l-2-4c0-3.5 1.5-7 5-9z" />
      <circle cx="12" cy="10" r="1.6" />
      <path d="M9 20c-1 1-1.5 1-2.5 1 0-1 0-1.5 1-2.5M15 20c1 1 1.5 1 2.5 1 0-1 0-1.5-1-2.5" />
    </>
  ),
};

export default function SectorIcon({ id, size = 28, ...props }) {
  const path = PATHS[id];
  if (!path) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {path}
    </svg>
  );
}
